import { DynamicTheme, ThemeColors, ThemeName } from './types';

const SECONDARY_COLOR_DEFAULT = '#3d3d3d';

export const FIELPET_DEFAULT_COLORS: ThemeColors = {
  primary: '#009F6B',
  secondary: '#424242',
  gray: '#666',
  gray_light: '#E9EBF0',
  icon_bg: '#EDFAF3',
  bg_light: '#FCFEFD',
};

export const THEMES = {
  FIELPET: {
    colors: {
      primary: FIELPET_DEFAULT_COLORS.primary,
      secondary: FIELPET_DEFAULT_COLORS.secondary,
    },
    themeName: 'FIELPET',
    brandName: 'Fielpet',
    logoUrl: 'https://app.fielpet.com/assets/img/FielPetLogo.png',
  },

  MEDICINA_ESENCIAL: {
  themeName: 'MEDICINA_ESENCIAL',
  brandName: 'Medicina Esencial',
  colors: {
    // Color principal fuerte que domina menús / títulos
    primary: '#FF1F49',

    // Color secundario más suave para acentos y CTAs
    secondary: '#FF5A75',

    // Fondo muy suave (casi blanco rosado)
    bg_light: '#FFF1F3',

    // Fondo/overlay para íconos o cards
    icon_bg: '#FFE5EA',
  },
  logoUrl: '/assets/logos/esencial_logo.png',
},

  MERCANTIL_ANDINA: {
    themeName: 'MERCANTIL_ANDINA',
    brandName: 'Mercantil Andina Mascotas',
    colors: {
      primary: '#263883',
      secondary: '#00aad4',
      icon_bg: '#e8ecf8',
      bg_light: '#F7F9FE',
    },
    logoUrl: '/assets/logos/mercantilandina_logo.png',
  },

  HIPOTECARIO: {
    themeName: 'HIPOTECARIO',
    brandName: 'Hipotecario Mascotas',
    colors: {
      primary: '#f76800',
      secondary: SECONDARY_COLOR_DEFAULT,
      icon_bg: '#fff0e6',
      bg_light: '#FFF9F3',
    },
    logoUrl: '/assets/logos/bancohipotecario_logo.png',
  },

  GALICIA: {
    themeName: 'GALICIA',
    brandName: 'Galicia Mascotas',
    colors: {
      primary: '#ff5900',
      secondary: '#bc001b',
      icon_bg: '#ffe9d6',
      bg_light: '#FFF7F0',
    },
    logoUrl: '/assets/logos/Galicia-Seguros-nuevo-logo.png',
  },

  SANCOR: {
    themeName: 'SANCOR',
    brandName: 'Sancor Mascotas',
    colors: {
      primary: '#ce0061',
      secondary: SECONDARY_COLOR_DEFAULT,
      icon_bg: '#fce3ef',
      bg_light: '#FFF6FB',
    },
    logoUrl: '/assets/logos/sancorseguro_logo.png',
  },

  ALLIANZ: {
    themeName: 'ALLIANZ',
    brandName: 'Allianz Mascotas',
    colors: {
      primary: '#022987',
      secondary: SECONDARY_COLOR_DEFAULT,
      icon_bg: '#e5ecfb',
      bg_light: '#F5F8FF',
    },
    logoUrl: '/assets/logos/allianz_logo.png',
  },
} as const;

// Función helper para obtener un theme seguro
export const getTheme = (themeName: ThemeName): DynamicTheme => {
  return THEMES[themeName] || THEMES.FIELPET;
};
